import { useEffect } from 'react';
import { getProfilePublicUrl } from '@nx/shared';
import { APP_BASE_PATH } from '../config/appBasePath';

function upsertMeta(
  selector: string,
  attribute: 'name' | 'property',
  key: string,
  content: string,
): void {
  let el = document.head.querySelector<HTMLMetaElement>(`${selector}[${attribute}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attribute, key);
    document.head.appendChild(el);
  }
  el.content = content;
}

export function useProfilePageMeta(profile: {
  title: string;
  description: string | null;
  tagline: string | null;
  avatarUrl: string | null;
  slug: string;
} | null): void {
  useEffect(() => {
    if (!profile) return;

    const title = `${profile.title} | N-Excelsior`;
    const description =
      profile.description?.trim() || profile.tagline?.trim() || profile.title;
    const url = getProfilePublicUrl(profile.slug, undefined, APP_BASE_PATH);

    document.title = title;
    upsertMeta('meta', 'name', 'description', description);
    upsertMeta('meta', 'property', 'og:title', title);
    upsertMeta('meta', 'property', 'og:description', description);
    upsertMeta('meta', 'property', 'og:type', 'profile');
    upsertMeta('meta', 'property', 'og:url', url);
    if (profile.avatarUrl) {
      upsertMeta('meta', 'property', 'og:image', profile.avatarUrl);
    }

    return () => {
      document.title = 'N-Excelsior';
    };
  }, [profile]);
}
